

const Archived = () => {
    return <div></div>
}

export default Archived